import React from "react";
import { Helmet } from "react-helmet";
import { MarketplaceBanner } from "../../blocks/marketplace-banner";
import { MarketplaceCreateApp } from "../../blocks/marketplace-create-app";
import { MarketplaceList } from "../../blocks/marketplace-list";
import { Footer } from "../../components/FooterV2";
import { Header } from "../../components/Header";
import { Notice } from "../../components/Notice";

// import { MarketplaceHeader } from "../../components/MarketplaceHeader";
import "./styles.less";

export const MarketplacePage = (props) => {
  const { macketplaceData } = props;
  return (
    <div className="marketplace-page">
      <Helmet>
        <title>
          统一身份认证应用集成_单点登录应用集成_企业应用集成平台-Authing身份云
        </title>
      </Helmet>
      <Header hasNotice />
      {/* <MarketplaceHeader /> */}
      <MarketplaceBanner />
      <MarketplaceList macketplaceData={macketplaceData} />
      <MarketplaceCreateApp />
      <Footer />
    </div>
  );
};
